// extracted by mini-css-extract-plugin
export default {"wrapper":"TextEditor_wrapper__qR8Ix","notPremium":"TextEditor_notPremium__R3QDg","textEditor":"TextEditor_textEditor__VYziF"};